import areEqual from 'fast-deep-equal'
import { useCallback, useEffect, useRef } from 'react'
import { diffLeaves } from 'src/utils/widgets'
import { switchCurrency } from 'src/utils/number/currency'
import { ENTITY } from 'src/consts'

const getCoordinates = props => ({
  x0: Math.floor(props.entry.x0),
  x1: Math.floor(props.entry.x1),
  y0: Math.floor(props.entry.y0),
  y1: Math.floor(props.entry.y1),
})

const getFilters = props => ({
  currency: props.currency,
  baseValue: props.baseValue,
  periods: props.periods,
})

export const useAnimation = (props, ref, enabled = true) => {
  const self = useRef({
    prevProps: props,
  })

  const removeLeafAnimation = useCallback(() => {
    if (window.autoUpdateMap) {
      window.autoUpdateMap.delete(`${props.leaf.data.name}${props.index}`)
    }
  }, [props.leaf.data.name, props.index])

  useEffect(() => {
    return () => {
      removeLeafAnimation()
    }
  }, [removeLeafAnimation])

  useEffect(() => {
    if (enabled) {
      const changed = diffLeaves(self.current.prevProps.leaf, props.leaf)
      if (
        !areEqual(getCoordinates(props), getCoordinates(self.current.prevProps))
      ) {
        removeLeafAnimation()
      }

      if (!areEqual(getFilters(props), getFilters(self.current.prevProps))) {
        removeLeafAnimation()
      } else if (changed) {
        const {
          leaf: {
            data: { name, symbol, price, change },
          },
          baseValue,
          currency,
          dominance,
          entity,
        } = props

        const state = {
          name,
          symbol,
          price,
          change,
          dominance,
          currency,
          entity,
        }

        const value =
          state[baseValue] && typeof state[baseValue] === 'number'
            ? state[baseValue].toFixed(0)
            : state[baseValue]

        const animation = changed > 0 ? 'leafGreen' : 'leafRed'
        const animationBg = 'leafanimation'

        if (window.autoUpdater) {
          window.autoUpdater.push({
            ref: ref.current,
            animation,
            animationBg,
            price: switchCurrency(currency, {
              price: entity === ENTITY.EXCHANGE ? value : price,
            }),
            change: `${Number(change) > 0 ? '+' : ''}${change}%`,
            dominance: `Dominance: ${dominance}`,
            symbol,
            type: 'leaf',
          })
        }
      }
    }

    self.current.prevProps = props
  }, [props, enabled, removeLeafAnimation, ref])
}
